import React from 'react';
import {
  Box,
  Button,
  SpaceBetween,
  Table,
  TableProps,
} from '@cloudscape-design/components';
import { Player } from '../../api';

export interface PlayersListProps {
  players: Player[];
  onDeletePlayer?: (player: Player) => void;
  onSavePreset?: (players: Player[]) => void;
}

export const PlayersList: React.FC<PlayersListProps> = (props) => {
  const columnDefinitions: TableProps.ColumnDefinition<Player>[] = [
    {
      id: 'name',
      header: 'Name',
      ariaLabel: () => 'Player name',
      cell: (player) => player.name,
    },
    {
      id: 'actions',
      header: 'Actions',
      maxWidth: 44,
      cell: (player) => {
        return (
          <Button
            variant="icon"
            ariaLabel="Delete player"
            iconName="close"
            onClick={() => props.onDeletePlayer?.(player)}
          />
        );
      },
    },
  ];

  return (
    <>
      <Box variant="h3">Current players</Box>
      <Table
        footer={
          props.players.length > 0 && (
            <Box float="right">
              <SpaceBetween direction="horizontal" size="m">
                <Button
                  onClick={() => {
                    props.players.forEach((p) => props.onDeletePlayer?.(p));
                  }}
                >
                  Clear players
                </Button>
                <Button onClick={() => props.onSavePreset?.(props.players)}>
                  Save as preset
                </Button>
              </SpaceBetween>
            </Box>
          )
        }
        columnDefinitions={columnDefinitions}
        variant="embedded"
        items={props.players}
        empty={
          <Box textAlign="center" color="inherit">
            <b>No players</b>
            <Box padding={{ bottom: 's' }} variant="p" color="inherit">
              Please use the form to add new player to the list.
            </Box>
          </Box>
        }
      />
    </>
  );
};
